import { useCallback, useEffect } from "react";
import { useLocation } from "react-router-dom";

import { useAppInsightsContext } from "@microsoft/applicationinsights-react-js";

import { useFormId } from "../hooks";
import { CustomEventProperties } from "./app-insights.types";

const APP_ID = "Forms.WebApp";

export const useAppInsightsPageViewTracker = () => {
  const appInsightPlugin = useAppInsightsContext();
  const location = useLocation();
  const formId = useFormId();

  useEffect(
    () => {
      appInsightPlugin.trackPageView &&
        appInsightPlugin.trackPageView({
          uri: location.pathname,
          properties: {
            formId,
            appId: APP_ID
          }
        });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [appInsightPlugin, location]
  );
};

export const useTrackAnalyticsEvent = () => {
  const appInsights = useAppInsightsContext();
  const formId = useFormId();
  return useCallback(
    (name: string, params: CustomEventProperties) =>
      appInsights.trackEvent({
        name,
        properties: { ...params, formId, appId: APP_ID }
      }),
    [appInsights, formId]
  );
};
